import script from "./TableBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TableBar.vue?vue&type=script&setup=true&lang=js"

import "./TableBar.vue?vue&type=style&index=0&id=4d959d5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d959d5c"]])

export default __exports__